import store from "../store";
import Constants from "../config/constants";
import { serviceGetNotification } from "../services/Notification.service";
import EventEmitter from "../libs/Events.utils";

export const FETCH_INIT = "FETCH_INIT_NOTIFICATION";
export const FETCHED = "FETCHED_NOTIFICATION";
export const FETCHED_FAIL = "FETCHED_FAIL_NOTIFICATION";
export const FETCHED_FILTER = "FETCHED_FILTER_NOTIFICATION";
export const NEXT_PREQUESTS = "NEXT_PREQUESTS";
export const PREV_PREQUESTS = "PREV_PREQUESTS";
export const FETCH_NEXT = "FETCH_NEXT_NOTIFICATION";
export const FILTER = "FILTER_NOTIFICATION";
export const RESET_FILTER = "RESET_FILTER_NOTIFICATION";
export const SET_SORTING = "SET_SORTING_NOTIFICATION";
export const SET_FILTER = "SET_FILTER_NOTIFICATION";
export const SET_PAGE = "SET_PAGE_NOTIFICATION";
export const CHANGE_PAGE = "CHANGE_PAGE_NOTIFICATION";
export const CHANGE_STATUS = "CHANGE_STATE_NOTIFICATION";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_NOTIFICATION";
export const CREATE_DATA = "CREATE_NOTIFICATION";
export const UPDATE_DATA = "UPDATE_NOTIFICATION";
export const DELETE_ITEM = "DELETE_NOTIFICATION";
export const PERMISSION = "PERMISSION";

export function actionFetchNotification(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetNotification({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionChangePageNotification(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function nextPRequestsClick() {
  return {
    type: NEXT_PREQUESTS,
    payload: null,
  };
}

export function actionFilterNotification(value) {
  const request = null;
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null });
    });
  };
}

export function actionChangeStatusNotification(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterNotification() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageNotification(page,  extraPayload = {}) {
  const stateData = store.getState().notification;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchNotification(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
        ...extraPayload
      })
    );
  }

  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
